/** Fixed-step game clock. Accumulates real time and emits 1/60s ticks. */
export class Clock {
  static readonly DT = 1 / 60;
  static readonly MAX_TICKS_PER_STEP = 8;

  private _ticks = 0;
  private _accumulator = 0;

  get ticks(): number {
    return this._ticks;
  }

  get dt(): number {
    return Clock.DT;
  }

  get accumulator(): number {
    return this._accumulator;
  }

  /** Render interpolation in [0, 1) after `step`. */
  get alpha(): number {
    return this._accumulator / Clock.DT;
  }

  /** Advance by elapsed real seconds. Returns how many fixed ticks were consumed. */
  step(elapsedSeconds: number): number {
    if (!Number.isFinite(elapsedSeconds) || elapsedSeconds <= 0) {
      return 0;
    }

    this._accumulator += elapsedSeconds;
    let consumed = 0;

    while (this._accumulator >= Clock.DT && consumed < Clock.MAX_TICKS_PER_STEP) {
      this._accumulator -= Clock.DT;
      this._ticks += 1;
      consumed += 1;
    }

    if (this._accumulator > Clock.DT * Clock.MAX_TICKS_PER_STEP) {
      this._accumulator = 0;
    } else if (consumed >= Clock.MAX_TICKS_PER_STEP && this._accumulator >= Clock.DT) {
      this._accumulator = 0;
    }

    return consumed;
  }
}
